(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-upsell"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cart-upsell-component')) {
    /**
     * Loads one recommended product for the current cart into its slot.
     * Reloads when the cart's product list changes (the outer element is morphed with new attributes).
     */
    class CartUpsellComponent extends HTMLElement {
      static observedAttributes = ['data-product-ids', 'data-source-id'];

      /** @type {AbortController | undefined} */
      #controller;

      connectedCallback() {
        this.#load();
      }

      disconnectedCallback() {
        this.#controller?.abort();
      }

      /**
       * @param {string} name
       * @param {string | null} oldValue
       * @param {string | null} newValue
       */
      attributeChangedCallback(name, oldValue, newValue) {
        if (this.isConnected && oldValue !== null && oldValue !== newValue) this.#load();
      }

      async #load() {
        this.#controller?.abort();
        const controller = new AbortController();
        this.#controller = controller;
        const slot = this.querySelector('[ref="slot"]');
        const { sourceId, url } = this.dataset;
        if (!slot || !sourceId || !url) return;

        for (const intent of ['complementary', 'related']) {
          const requestUrl = new URL(url, window.location.origin);
          requestUrl.searchParams.set('product_id', sourceId);
          requestUrl.searchParams.set('limit', '10');
          requestUrl.searchParams.set('intent', intent);
          requestUrl.searchParams.set('section_id', 'cart-upsell');
          try {
            const response = await fetch(requestUrl, { signal: controller.signal });
            if (!response.ok) continue;
            const html = new DOMParser().parseFromString(await response.text(), 'text/html');
            const content = html.querySelector('[data-cart-upsell-content]');
            if (controller.signal.aborted) return;
            if (content?.querySelector('.cart-upsell')) {
              slot.replaceChildren(...content.childNodes);
              return;
            }
          } catch (error) {
            if (error instanceof DOMException && error.name === 'AbortError') return;
          }
        }
        if (!controller.signal.aborted) slot.replaceChildren();
      }
    }

    customElements.define('cart-upsell-component', CartUpsellComponent);
  }
  } catch(e) { console.error(e); }
})();

})();
